import ConfirmModal from 'components/ConfirmModal'
import OrderContext from 'pages/Order/_context'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { deleteDelivery } from 'state/Orders'

export default function InHouseDeliveryModal({ show, doClose }) {
	const { t }    = useTranslation()
	const dispatch = useDispatch()
	const order    = useContext(OrderContext)

	async function doSubmit() {
		await dispatch(deleteDelivery(order.id)).finally(doClose)
	}

	return 	<ConfirmModal {...{ show, doClose, doSubmit }} size="md" dangerous
	                      title={t('Confirm in-house delivery')}
	                      cancelText={t('No, go back')}
	                      confirmTexts={[t('We will deliver'), t('Confirming')]}
	>
		<Trans>
			<p>Would you like to handle this order with an in-house driver?</p>
			<p>Please confirm, as this will avoid third-party delivery fees being charged to your account.</p>
		</Trans>
	</ConfirmModal>
}

InHouseDeliveryModal.propTypes = {
	show   : PropTypes.bool.isRequired,
	doClose: PropTypes.func.isRequired,
}
